
export default {
  day: [
    { value: 1, name: '01' },
    { value: 2, name: '02' },
    { value: 3, name: '03' },
    { value: 4, name: '04' },
    { value: 5, name: '05' },
    { value: 6, name: '06' },
    { value: 7, name: '07' },
    { value: 8, name: '08' },
    { value: 9, name: '09' },
    { value: 10, name: '10' },
    { value: 11, name: '11' },
    { value: 12, name: '12' },
    { value: 13, name: '13' },
    { value: 14, name: '14' },
    { value: 15, name: '15' },
    { value: 16, name: '16' },
    { value: 17, name: '17' },
    { value: 18, name: '18' },
    { value: 19, name: '19' },
    { value: 20, name: '20' },
    { value: 21, name: '21' },
    { value: 22, name: '22' },
    { value: 23, name: '23' },
    { value: 24, name: '24' },
    { value: 25, name: '25' },
    { value: 26, name: '26' },
    { value: 27, name: '27' },
    { value: 28, name: '28' },
    { value: 29, name: '29' },
    { value: 30, name: '30' }
  ],
  month: [
    { value: 0, name: 'jan' },
    { value: 1, name: 'feb' },
    { value: 2, name: 'mar' },
    { value: 3, name: 'apr' },
    { value: 4, name: 'may' },
    { value: 5, name: 'jun' },
    { value: 6, name: 'jul' },
    { value: 7, name: 'aug' },
    { value: 8, name: 'sep' },
    { value: 9, name: 'oct' },
    { value: 10, name: 'nov' },
    { value: 11, name: 'dec' }
  ],
  // set list year from 2010 to current year
  year: Array(new Date().getFullYear() - 2010 + 1)
    .fill()
    .map((v, i) => ({ value: i + 2010, name: Number(i + 2010).toString() })).reverse(),
  quarter: [
    { value: 1, name: 'Q1' },
    { value: 2, name: 'Q2' },
    { value: 3, name: 'Q3' },
    { value: 4, name: 'Q4' }
  ],
  time: [
    { value: 'am', name: 'am' },
    { value: 'pm', name: 'pm' }
  ],
  min: [
    { value: 0, name: '00' },
    { value: 5, name: '5' },
    { value: 10, name: '10' },
    { value: 15, name: '15' },
    { value: 20, name: '20' },
    { value: 25, name: '25' },
    { value: 30, name: '10' },
    { value: 35, name: '35' },
    { value: 40, name: '40' },
    { value: 45, name: '45' },
    { value: 50, name: '50' },
    { value: 55, name: '55' }
  ],
  hours: [
    { value: 1, name: '1' },
    { value: 2, name: '2' },
    { value: 3, name: '3' },
    { value: 4, name: '4' },
    { value: 5, name: '5' },
    { value: 6, name: '6' },
    { value: 7, name: '7' },
    { value: 8, name: '8' },
    { value: 9, name: '9' },
    { value: 10, name: '10' },
    { value: 11, name: '11' },
    { value: 12, name: '12' }
  ],
  dateTabs: [
    {
      name: 'compare_date',
      id: 0
    },
    {
      name: 'date_range',
      id: 1
    }
  ],
  dateRangeTabs: [
    {
      name: 'year',
      id: 0
    },
    {
      name: 'month',
      id: 2
    },
    {
      name: 'week',
      id: 3
    },
    {
      name: 'day',
      id: 4
    }
  ]
}
